import {
    orderBy as _orderBy,
} from 'lodash';
import SpecialEvent from '@models/specials/SpecialEvent';
import Vue from 'vue';

export const specialGridState = Vue.observable({
    offsetTop: 0,
});

export const SCROLLING_DISABLED = -1;

export default class SpecialGridPreparation {
    private events: SpecialEvent[];

    constructor(
        events: SpecialEvent[],
    ) {
        this.events = events;
    }

    public getContent() {
        return _orderBy(this.events, 'order')
            .map((event) => this.createItem(event));
    }

    private createItem(event: SpecialEvent) {
        return {
            ...event,
            height: EVENT_ROW_HEIGHT
        };
    }
}

const EVENT_ROW_HEIGHT = 40;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/app/modules/shared/special/helpers.ts